import React from "react";
import loaderGif from "app/assets/images/loader.gif";

interface LoaderProps {
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ text = "" }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#D9D9D9] bg-opacity-80">
      <div className="flex flex-col items-center">
        <img src={loaderGif} alt="loaderGif" />
        {text && (
          <p className="text-[#313131] font-Mulish  text-base font-normal">
            {text}
          </p>
        )}
      </div>
    </div>
  );
};

export default Loader;
